module.exports = __webpack_public_path__ + "static/media/mount-suspended-direct.91b7d486.png";